export const CREATE_CATALOG_MANAGEMENT_UNITS = "CREATE_CATALOG_MANAGEMENT_UNITS";
export const LOAD_CATALOG_MANAGEMENT_UNITS_SUCCESS = "LOAD_CATALOG_MANAGEMENT_UNITS_SUCCESS";
export const CREATE_CATALOG_MANAGEMENT_UNITS_SUCCESS = "CREATE_CATALOG_MANAGEMENT_UNITS_SUCCESS";
export const UPDATE_CATALOG_MANAGEMENT_UNITS_SUCCESS = "UPDATE_CATALOG_MANAGEMENT_UNITS_SUCCESS";
export const BEGIN_API_CALL = "BEGIN_API_CALL";
export const API_CALL_ERROR = "API_CALL_ERROR";
export const DELETE_CATALOG_MANAGEMENT_UNITS_OPTIMISTIC = "DELETE_CATALOG_MANAGEMENT_UNITS_OPTIMISTIC";